{
  "_comment": "[CI-LOCKED] 此文件的内容已锁定。欢迎发布内容，但更改验证可能会延迟。",
  "ACCESS_KEY_ALT": "Alt + Shift + $1",
  "ACCESS_KEY_FOR_MAC_ALT": "控制键 + 选项键 + $1",
  "ACTIVITY_BOT_SAID_ALT": "机器人 $1 说:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "智能体",
  "ACTIVITY_YOU_SAID_ALT": "您说:",
  "ACTIVITY_BOT_ATTACHED_ALT": "机器人附加了:",
  "ACTIVITY_CODE_ALT": "代码示例: $1",
  "ACTIVITY_CONTENT_CAUTION": "AI 生成的内容可能不正确",
  "ACTIVITY_CODE_CAUTION": "AI 生成的代码。请仔细审查和使用",
  "ACTIVITY_ERROR_BOX_TITLE": "错误消息",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "单击以进行交互。",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "消息是交互式消息。",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "消息中有一个或多个链接。",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "发送失败。",
  "ACTIVITY_YOU_ATTACHED_ALT": "您附加了:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 个附件。",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 个附件。",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 个附件。",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 个附件。",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 个附件。",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "发送失败。[重试][RETRY]。",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "正在发送",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "已于 $1 发送",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "刚刚",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "1 小时前",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "1 分钟前",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "今天",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "昨天",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "自适应卡片分析错误",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "自适应卡片呈现错误",
  "ATTACHMENT_AUDIO": "音频剪辑。",
  "ATTACHMENT_CARD": "卡片: $1 $2 $3",
  "ATTACHMENT_FILE": "文件: $1",
  "ATTACHMENT_IMAGE": "图像",
  "ATTACHMENT_TEXT": "文本: $1",
  "ATTACHMENT_VIDEO": "视频剪辑",
  "AVATAR_ALT": "$1 头像",
  "CAROUSEL_FLIPPER_NEXT_ALT": "下一个",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "上一个",
  "CITATION_MODEL_DIALOG_ALT": "引文",
  "CLOSE_BUTTON_ALT": "关闭",
  "COLLAPSIBLE_GROUPING_TITLE": "正在思考...",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "如果未提供摘要，则当机器人在组中撰写响应消息时，会显示此信息。",
  "COLLAPSE_BUTTON_LESS": "显示更少",
  "COLLAPSE_BUTTON_LESS.comment": "这是用于折叠消息组的 V 形按钮的文本。当最终用户单击按钮时，消息组会折叠。",
  "COLLAPSE_BUTTON_MORE": "显示更多",
  "COLLAPSE_BUTTON_MORE.comment": "这是用于展开消息组的 V 形按钮的文本。当最终用户单击按钮时，消息组会展开。",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "已连接",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "正在连接...",
  "CONNECTIVITY_STATUS_ALT_FATAL": "无法连接。",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "发生网络中断。正在重新连接...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "呈现错误。请检查控制台或联系机器人开发者。",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "连接所花费的时间长于平时。",
  "CONNECTIVITY_STATUS_ALT": "连接状态: $1",
  "COPY_BUTTON_TEXT": "复制",
  "COPY_BUTTON_COPIED_TEXT": "已复制",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "提交",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "取消",
  "FEEDBACK_FORM_PLACEHOLDER": "提供尽可能多的详细信息，但不要包含任何私人或敏感信息。",
  "FEEDBACK_FORM_TITLE": "与我们分享您的体验",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "下载文件 '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "下载文件 '$1'，大小为 $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1' 的大小为 $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "在新窗口中打开；外部。",
  "RECEIPT_CARD_TAX": "税款",
  "RECEIPT_CARD_TOTAL": "总额",
  "RECEIPT_CARD_VAT": "增值税",
  "REFERENCE_LIST_HEADER_ONE": "$1 条引用",
  "REFERENCE_LIST_HEADER_FEW": "$1 条引用",
  "REFERENCE_LIST_HEADER_MANY": "$1 条引用",
  "REFERENCE_LIST_HEADER_OTHER": "$1 条引用",
  "REFERENCE_LIST_HEADER_TWO": "$1 条引用",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "删除附件 $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "删除",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "文件",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "图像",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "无法发送空消息。",
  "SPEECH_INPUT_LISTENING": "正在倾听...",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "麦克风关闭",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "麦克风打开",
  "SPEECH_INPUT_STARTING": "正在启动...",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "下一个",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "上一个",
  "SUGGESTED_ACTIONS_LABEL_ALT": "建议的操作",
  "TEXT_INPUT_ALT": "消息输入框",
  "TEXT_INPUT_PLACEHOLDER": "键入消息",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "开始说话...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "正在收听...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "正在处理...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "说话以中断...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "发送",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "咨询",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "上传文件",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "电话键盘",
  "TEXT_INPUT_DROP_ZONE": "放置文件",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "超出消息长度",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "仅支持一位数的输入",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 个附件",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 个附件",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 个附件",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 个附件",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 个附件",
  "TOAST_ACCORDION_FEW": "$1 条通知: 单击此处以查看详细信息",
  "TOAST_ACCORDION_MANY": "$1 条通知: 单击此处以查看详细信息",
  "TOAST_ACCORDION_OTHER": "$1 条通知: 单击此处以查看详细信息",
  "TOAST_ACCORDION_TWO": "$1 条通知: 单击此处以查看详细信息",
  "TOAST_ALT_ERROR": "出错",
  "TOAST_ALT_INFO": "信息",
  "TOAST_ALT_SUCCESS": "成功",
  "TOAST_ALT_WARN": "警告",
  "TOAST_DISMISS_BUTTON": "取消",
  "TOAST_TITLE_ALT": "通知",
  "TRANSCRIPT_ARIA_LABEL_ALT": "聊天历史记录，按箭头键导航。",
  "TRANSCRIPT_ARIA_ROLE_ALT": "聊天历史记录",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "消息是交互式消息。按 Shift Tab 键 2 到 3 次切换到聊天历史记录。然后单击消息以进行交互。",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "消息中有一个或多个链接。按 Shift Tab 键 2 到 3 次切换到聊天历史记录。然后单击消息以进行交互。",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "消息提供了建议的操作。请按 Shift + Tab 键 2 到 3 次进行选择。",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "消息提供了建议的操作。请按 $1 进行选择。",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "无法发送消息。",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "有新消息。按 $1 可聚焦 \"$2\" 按钮。",
  "TRANSCRIPT_MORE_MESSAGES": "更多消息",
  "TRANSCRIPT_NEW_MESSAGES": "新消息",
  "TRANSCRIPT_TERMINATOR_TEXT": "聊天历史记录结束",
  "TYPING_INDICATOR_ALT": "显示键入指示器",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 正在键入。",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 和其他人正在键入。",
  "VIEW_CODE_BUTTON_TEXT": "代码",
  "VOTE_COMPLETE_ALT": "已记录反馈",
  "VOTE_COMPLETE_ALT.comment": "这适用于屏幕阅读器。带有顶/踩图标的按钮标签。此标签在反馈被记录时使用。",
  "VOTE_DISLIKE_ALT": "不喜欢",
  "VOTE_LIKE_ALT": "喜欢"
}